
import ModuleTM from "@/modules/tm";
import TMModel from "@/modules/tm/api/tm/tm-model";
import React, { useCallback, useEffect, useState } from "react";
import TMTransferListItem from "../list/item";
import styles from "./index.module.scss";

interface ITMTransferRecommendProps {
  hasLogin: boolean;
}

const TMTransferRecommend: React.FC<ITMTransferRecommendProps> = (props) => {

  const { hasLogin } = props;
  const [initOk, setInitOk] = useState(false);
  const [dataSource, setDataSource] = useState<TMModel[]>();

  const request = useCallback(async () => {
    let response = await ModuleTM.Api.recommend();
    if (!response.success) {
      return;
    }

    setDataSource(response.model?.list);
  }, []);

  useEffect(() => {
    if (initOk) return;
    request().then(() => {
      setInitOk(true);
    });
  }, [initOk, request]);

  if (!dataSource || dataSource.length === 0) {
    return <div></div>;
  }

  return (
    <div className={styles.container}>
      <div className="flex-row flex-cross-axis-end">
        <h1>精品推荐</h1>
        <h2>没有找到想要的商标，您还可以看看这些商标</h2>
      </div>
      <div className={`${styles.listContainer} flex-row-wrap`}>
        {dataSource.map((item, index) => {
          return (
            <TMTransferListItem
              key={index}
              model={item}
              hasLogin={hasLogin}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TMTransferRecommend;
